module.exports = __webpack_public_path__ + "img/12_Proximal-D.48f6219a.png";